<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <card
      v-else-if="!this.loading && !this.errormessage"
      class="mt-3"
    >
      <el-table
        :data="rowData"
        header-row-class-name="text-danger"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        @cell-click="onCellClick"
        v-if="rowData.length > 0"
      >
        <el-table-column
          label="Name"
          sortable
          property="FullName"
          label-class-name="text-danger"
          class-name="text-primary pointer"
        />
        <el-table-column
          class-name="d-none d-md-table-cell text-primary pointer"
          label-class-name="text-danger"
          sortable
          label="Email"
        >
          <template slot-scope="props">
            <a :href="'mailto:' + props.row.EmailAddress">{{ props.row.EmailAddress }}</a>
          </template>
        </el-table-column>
        <el-table-column
          class-name="d-none d-md-table-cell"
          label="City"
          property="City"
          width="120px"
        />
        <el-table-column
          class-name="d-none d-md-table-cell text-center"
          label="State"
          property="State"
          width="55px"
        />
        <el-table-column
          label="Phone"
          property="PhoneNumber"
          width="92px"
        />
        <el-table-column
          label="Paid"
          align="right"
          property="AmountPaid"
          :formatter="formatCurrency"
          width="65px"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="140"
          label="Actions"
        >
          <template slot-scope="props">
            <p-button
              type="success"
              class="mt-1 mb-1"
              size="sm"
              title="Invite"
              icon
              @click="invite(null, props.row)"
              v-if="
                props.row.value !== 0 && !props.row.IsUser && props.row.FullName
              "
            >
              <i class="nc-icon nc-email-85" />
            </p-button>
            <p-button
              type="info"
              size="sm"
              class="mt-1 mb-1"
              title="Edit"
              icon
              @click="showEditDialog(props.row)"
            >
              <i class="fa fa-edit" />
            </p-button>
            <p-button
              type="danger"
              size="sm"
              class="mt-1 mb-1"
              title="Delete"
              icon
              @click="deleteConfirm(props.row)"
            >
              <i class="fa fa-times" />
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <modal
        :show.sync="showEdit"
        class="modal-primary"
        :show-close="false"
        header-classes="justify-content-center"
        type="mini"
      >
        <div
          slot="header"
          class="ml-4"
        >
          <h6>
            <i class="fa fa-edit mr-2" /><span class="text-danger">{{ editItem.ScouterKey ? "Edit" : "Add" }} {{ scouterTypeLabel }}</span>
          </h6>
        </div>
        <ValidationObserver ref="form">
          <form @submit.prevent="validate">
            <div class="row">
              <div class="col-12">
                <ValidationProvider
                  name="firstName"
                  rules="required|max:100"
                  v-slot="{ passed, failed }"
                >
                  <fg-input
                    name="firstName"
                    key="firstNameInput"
                    :error="failed ? 'The ' + scouterTypeLabel + '\'s First Name is required' : null"
                    :has-success="passed"
                    required
                    :label="scouterTypeLabel + '\'s First Name'"
                    placeholder=""
                    max-length="100"
                    v-model="editItem.FirstName"
                    ref="firstNameInput"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="lastName"
                  rules="required|max:100"
                  v-slot="{ passed, failed }"
                >
                  <fg-input
                    name="lastName"
                    :error="failed ? 'The ' + scouterTypeLabel + '\'s Last Name is required' : null"
                    :has-success="passed"
                    required
                    :label="scouterTypeLabel + '\'s Last Name'"
                    placeholder=""
                    max-length="100"
                    v-model="editItem.LastName"
                  />
                </ValidationProvider>
                <fg-input
                  name="preferredName"
                  label="Preferred Name"
                  placeholder=""
                  max-length="255"
                  v-model="editItem.PreferredName"
                />
                <ValidationProvider
                  name="emailAddress"
                  rules="email|max:255"
                  v-slot="{ passed, failed }"
                >
                  <fg-input
                    name="emailAddress"
                    label="Email Address"
                    :error="
                      failed ? 'Please provide a valid email address.' : null
                    "
                    :has-success="passed"
                    max-length="255"
                    type="email"
                    placeholder=""
                    v-model="editItem.EmailAddress"
                  />
                </ValidationProvider>
                <fg-input
                  name="street"
                  label="Street Address"
                  max-length="255"
                  placeholder=""
                  v-model="editItem.StreetAddress"
                />
                <fg-input
                  name="city"
                  label="City"
                  max-length="255"
                  placeholder=""
                  v-model="editItem.City"
                />
                <fg-input>
                  <label>State</label>
                  <el-select
                    class="select-default2"
                    size="large"
                    name="state"
                    placeholder=""
                    v-model="editItem.State"
                  >
                    <el-option
                      v-for="option in states"
                      class="select-default2"
                      :value="option.key"
                      :label="option.name"
                      :key="option.key"
                    />
                  </el-select>
                </fg-input>
                <fg-input
                  name="zipCode"
                  label="Zip Code"
                  max-length="10"
                  placeholder=""
                  v-model="editItem.ZipCode"
                />
                <fg-input
                  name="phoneNumber"
                  label="Phone Number"
                  max-length="20"
                  type="tel"
                  placeholder=""
                  v-model="editItem.PhoneNumber"
                />
                <label>Amount Paid</label>
                <fg-input
                  name="paid"
                  type="number"
                  placeholder=""
                  v-model="editItem.AmountPaid"
                >
                  <template slot="addonLeft">
                    $
                  </template>
                </fg-input>
              </div>
            </div>
          </form>
        </ValidationObserver>
        <template slot="footer">
          <p-button
            type="danger"
            class="mr-2"
            @click="showEdit = false"
          >
            Cancel
          </p-button>
          <p-button
            type="success"
            class="mr-2"
            @click="save"
          >
            Save
          </p-button>
        </template>
      </modal>
      <button
        type="button"
        class="btn btn-success"
        @click="showAddDialog"
      >
        Add {{ scouterTypeLabel }}
      </button>
    </card>
  </div>
</template>

<script>
import scouterApi from '@/services/api/scouter'
import inviteApi from '@/services/api/invitation'
import statesList from '@/services/static/states.js'
import oops from '@/components/_main/oops.vue'
import Modal from '@/plugins/paper-components/modal.vue'

export default {
  name: 'ScouterEdit',
  props: {
    scouterType: {
      type: String,
      default: null
    }
  },
  components: {
    oops,
    Modal
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: {
        padding: '0',
        height: '20px',
        'font-size': '10px',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      },
      rowData: null,
      inviteInfo: {
        invited: ''
      },
      showEdit: false,
      editItem: {},
      loading: true,
      errormessage: null,
      states: null,
      tempHolding: null
    }
  },
  computed: {
    scouterTypeLabel: function () {
      if (this.scouterType === 'participant') {
        return 'Participant'
      } else if (this.scouterType === 'staff') {
        return 'Staff Member'
      } else {
        return ''
      }
    },
    courseScouterTypeName: function () {
      if (this.scouterType && this.scouterType.length > 0) {
        return (
          this.scouterType.charAt(0).toUpperCase() + this.scouterType.slice(1)
        )
      } else {
        return ''
      }
    }
  },
  created () {
    this.states = statesList.GetStates()
  },
  mounted () {
    scouterApi
      .list(this.$root.courseKey, this.scouterType)
      .then(x => {
        this.rowData = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
    this.tempHolding = this.$refs.firstNameInput
  },
  methods: {
    showAddDialog: function () {
      this.editItem = {}
      this.showEdit = true
      this.$nextTick(function () {
        this.$refs.firstNameInput.$refs.inputElement.focus()
      })
    },
    showEditDialog: function (p) {
      this.editItem = p
      this.showEdit = true
      this.$nextTick(function () {
        this.$refs.firstNameInput.$refs.inputElement.focus()
      })
    },
    onCellClick: function (row, column, cell, event) {
      this.tempHolder = { c: cell, r: row, co: column, e: event }
      if (column.label === 'Name') {
        const path = '/staff/participant?s=' + row.ScouterKey + '&r=' + this.scouterType + '-edit'
        this.$router.push(path)
      }
    },
    validate: function () {
      return this.$refs.form.validate().then(res => {
        this.save()
        return res
      })
    },
    save: function () {
      const core = {
        ScouterKey: this.editItem.ScouterKey,
        FirstName: this.editItem.FirstName,
        LastName: this.editItem.LastName,
        PreferredName: this.editItem.PreferredName,
        EmailAddress: this.editItem.EmailAddress,
        StreetAddress: this.editItem.StreetAddress,
        City: this.editItem.City,
        State: this.editItem.State,
        ZipCode: this.editItem.ZipCode,
        PhoneNumber: this.editItem.PhoneNumber,
        AmountPaid: this.editItem.AmountPaid
      }

      scouterApi
        .updateScouterFromCore(
          this.$root.courseKey,
          core,
          this.courseScouterTypeName
        )
        .then(x => {
          this.rowData = x
          this.$notify({
            message: 'The ' + this.scouterTypeLabel + ' update complete.',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.$emit('scouter-added')
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error updating this scouter.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
      this.showEdit = false
    },
    formatCurrency: function (row, column, cellValue, index) {
      return '$ ' + cellValue.toFixed(2)
    },
    deleteConfirm: function (data) {
      const msg = 'Are you sure you want to remove ' + data.FullName + '?'
      this.$confirm(msg, 'Are you sure?', {
        buttonSize: 'sm',
        centered: true
      }).then(() => {
        this.deleteScouter(data)
      })
    },
    deleteScouter: function (data) {
      if (this.scouterType === 'participant') {
        scouterApi
          .removeParticipant(this.$root.courseKey, data.CourseScouterId)
          .then(x => {
            this.rowData = x
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error deleting this scouter.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
      } else if (this.scouterType === 'staff') {
        scouterApi
          .removeMemberFromStaff(this.$root.courseKey, data.CourseScouterId)
          .then(x => {
            this.rowData = x
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error removing this scouter from your staff.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
      }
    },
    invite: function (event, data) {
      const courseScouterTypeId = 1
      inviteApi
        .get(this.$root.courseKey, data.ScouterKey, courseScouterTypeId)
        .then(x => {
          this.showInvitation(x, data)
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    showInvitation: function (inviteInfo, data) {
      const html =
        '<p class="text-full">Invite Code: ' +
        inviteInfo.InvitationCode +
        '</p><p class="text-full">URL: <span class="text-primary">' +
        inviteInfo.Url +
        '</span></p>'
      this.$alert(html, {
        dangerouslyUseHTMLString: true,
        customClass: 'invite'
      })
    }
  }
}
</script>
<style lang="css" scoped>
.invite {
  width: 50%;
}
</style>
